var _circle, _circle2, _circle3, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 143,
    viewBox: "0 0 144 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 61,
    fill: "#00826A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 45,
    fill: "#00826A"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 31,
    fill: "#00826A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 77.6L61.4 72L59.5333 73.8667L67 81.3333L83 65.3333L81.1333 63.4667L67 77.6Z",
    fill: "#F0FAF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6486 13.8118L30.0127 14.6351L29.6507 13.0835L30.8559 12.0395L29.2689 11.9048L28.6486 10.4414L28.0284 11.9048L26.4414 12.0395L27.6466 13.0835L27.2846 14.6351L28.6486 13.8118Z",
    fill: "#00826A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.6486 3.81184L80.0127 4.63513L79.6507 3.08346L80.8559 2.03945L79.2689 1.90482L78.6486 0.441437L78.0284 1.90482L76.4414 2.03945L77.6466 3.08346L77.2846 4.63513L78.6486 3.81184Z",
    fill: "#00826A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64864 66.8118L7.0127 67.6351L6.65072 66.0835L7.85585 65.0395L6.26887 64.9048L5.64864 63.4414L5.02842 64.9048L3.44144 65.0395L4.64657 66.0835L4.28459 67.6351L5.64864 66.8118Z",
    fill: "#00826A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.64864 111.812L4.0127 112.635L3.65072 111.083L4.85585 110.039L3.26887 109.905L2.64864 108.441L2.02842 109.905L0.441437 110.039L1.64657 111.083L1.28459 112.635L2.64864 111.812Z",
    fill: "#00826A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6486 137.812L59.0127 138.635L58.6507 137.083L59.8559 136.039L58.2689 135.905L57.6486 134.441L57.0284 135.905L55.4414 136.039L56.6466 137.083L56.2846 138.635L57.6486 137.812Z",
    fill: "#00826A"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64864 91.8118L11.0127 92.6351L10.6507 91.0835L11.8559 90.0395L10.2689 89.9048L9.64864 88.4414L9.02842 89.9048L7.44144 90.0395L8.64657 91.0835L8.28459 92.6351L9.64864 91.8118Z",
    fill: "#00826A"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.649 28.8118L124.013 29.6351L123.651 28.0835L124.856 27.0395L123.269 26.9048L122.649 25.4414L122.028 26.9048L120.441 27.0395L121.647 28.0835L121.285 29.6351L122.649 28.8118Z",
    fill: "#00826A"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.6486 140.812L91.0127 141.635L90.6507 140.083L91.8559 139.039L90.2689 138.905L89.6486 137.441L89.0284 138.905L87.4414 139.039L88.6466 140.083L88.2846 141.635L89.6486 140.812Z",
    fill: "#00826A"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.649 38.8118L133.013 39.6351L132.651 38.0835L133.856 37.0395L132.269 36.9048L131.649 35.4414L131.028 36.9048L129.441 37.0395L130.647 38.0835L130.285 39.6351L131.649 38.8118Z",
    fill: "#00826A"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.6486 131.812L101.013 132.635L100.651 131.083L101.856 130.039L100.269 129.905L99.6486 128.441L99.0284 129.905L97.4414 130.039L98.6466 131.083L98.2846 132.635L99.6486 131.812Z",
    fill: "#00826A"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_1217_74843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.919 11.0791L107.452 12.6081L106.78 9.72645L109.018 7.78757L106.071 7.53753L104.919 4.81982L103.767 7.53753L100.82 7.78757L103.058 9.72645L102.386 12.6081L104.919 11.0791Z",
    fill: "#00826A"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip1_1217_74843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9189 122.079L26.4522 123.608L25.7799 120.726L28.018 118.788L25.0708 118.538L23.9189 115.82L22.7671 118.538L19.8198 118.788L22.0579 120.726L21.3857 123.608L23.9189 122.079Z",
    fill: "#00826A"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip2_1217_74843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.919 93.0791L141.452 94.6081L140.78 91.7264L143.018 89.7876L140.071 89.5375L138.919 86.8198L137.767 89.5375L134.82 89.7876L137.058 91.7264L136.386 94.6081L138.919 93.0791Z",
    fill: "#00826A"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip3_1217_74843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.919 120.079L123.452 121.608L122.78 118.726L125.018 116.788L122.071 116.538L120.919 113.82L119.767 116.538L116.82 116.788L119.058 118.726L118.386 121.608L120.919 120.079Z",
    fill: "#00826A"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip4_1217_74843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9189 28.0791L13.4522 29.6081L12.7799 26.7264L15.018 24.7876L12.0708 24.5375L10.9189 21.8198L9.76708 24.5375L6.81982 24.7876L9.05793 26.7264L8.38568 29.6081L10.9189 28.0791Z",
    fill: "#00826A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1217_74843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.83784,
    height: 9.83784,
    fill: "white",
    transform: "translate(100 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1217_74843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.83784,
    height: 9.83784,
    fill: "white",
    transform: "translate(19 115)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1217_74843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.83784,
    height: 9.83784,
    fill: "white",
    transform: "translate(134 86)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1217_74843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.83784,
    height: 9.83784,
    fill: "white",
    transform: "translate(116 113)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1217_74843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.83784,
    height: 9.83784,
    fill: "white",
    transform: "translate(6 21)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b91a73ede1961d47f85ba527f50b9591.svg";
export { ForwardRef as ReactComponent };